/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react'

import { useShallow } from 'zustand/react/shallow'
import { useGlobalChatStore } from '#app/routes/chat+/index.tsx'

type UseHandleNewAssistantMessageParams = {
	messageFetcher: any
	isCurrentlyStreaming: boolean
	messages: { content: string }[]
	conversationId: string
	titleFetcher: any
}

export function useHandleNewAssistantMessage({
	messageFetcher,
	isCurrentlyStreaming,
	messages,
	conversationId,
	titleFetcher,
}: UseHandleNewAssistantMessageParams) {
	const dispatch = useGlobalChatStore(useShallow(state => state.dispatch))

	useEffect(() => {
		if (messageFetcher.data && !isCurrentlyStreaming && messages.length > 0) {
			if (messageFetcher.data.type === 'create_new_assistant_message') {
				dispatch({
					type: 'SET_IS_CURRENTLY_STREAMING',
					isCurrentlyStreaming: true,
				})

				const lastMessage = messages[messages.length - 1]?.content

				const formData = new FormData()
				formData.append('_action', 'new_title')
				formData.append('conversationId', conversationId)
				formData.append('message', lastMessage)

				titleFetcher.submit(formData, {
					method: 'post',
				})
			}
		}
	}, [messageFetcher])
}
